import { format } from 'date-fns/format';

export interface TimestampProps {
  className?: string;
  format?: string;
  value?: Date | string | number;
}

export const Timestamp = ({ value, format, ...other }: TimestampProps) =>
  value ? <time {...other}>{formatTimestamp(value, format)}</time> : null;

export const formatTimestamp = (
  value: Date | string | number | undefined,
  fmt: string = 'Pp'
) => (value ? format(new Date(value), fmt) : '');
